import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';

import initHero from './components/hero';
import initInfo from './components/info';
// import initCookies from './components/cookies';

// initCookies();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const hero = document.querySelector('.js-hero');

if (hero) {
    initHero(hero);
}

const infoEl = document.querySelector('.js-info');

if (infoEl) {
    initInfo(infoEl);
}
